export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";